import { useState, useRef, useLayoutEffect } from "react";

type Props = { margin?: number };

const useDimensions = ({ margin }: Props) => {
  const safeSpace = useRef<number>(88);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [navbar, setNavbar] = useState<number>(0);
  const [header, setHeader] = useState<number>(0);
  const [safeHeight, setSafeHeight] = useState<number>(0);
  const [contentHeight, setContentHeight] = useState<number>(0);

  const calculateHeights = () => {
    const nav = document.querySelector(".add-border-bottom")?.clientHeight || 0;
    const head = document.querySelector("header")?.clientHeight || 0;
    const winHeight = window.innerHeight;

    setWindowHeight(winHeight);
    setNavbar(nav);
    setHeader(head);
    setSafeHeight(winHeight - nav - head - safeSpace.current - (margin || 0));
    setContentHeight(winHeight - (head + 22));
  };

  useLayoutEffect(() => {
    calculateHeights(); // Run once when component mounts

    window.addEventListener("resize", calculateHeights);
    return () => {
      window.removeEventListener("resize", calculateHeights);
    };
  }, [margin]);

  return { windowHeight, navbar, header, safeHeight, contentHeight };
};

export default useDimensions;
